import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback-dashboard w-full" }
const _hoisted_2 = { class: "dashboard-hero" }
const _hoisted_3 = { class: "filter-card" }
const _hoisted_4 = { class: "filter-grid" }
const _hoisted_5 = { class: "field-block" }
const _hoisted_6 = { class: "field-block" }
const _hoisted_7 = { class: "field-block" }
const _hoisted_8 = { class: "quick-actions" }
const _hoisted_9 = { class: "metric-grid" }
const _hoisted_10 = { class: "metric-card metric-total" }
const _hoisted_11 = { class: "metric-card" }
const _hoisted_12 = { class: "metric-card" }
const _hoisted_13 = { class: "metric-card" }
const _hoisted_14 = { class: "chart-grid" }
const _hoisted_15 = { class: "chart-card chart-wide" }
const _hoisted_16 = { class: "chart-title-row" }
const _hoisted_17 = { class: "chart-shell" }
const _hoisted_18 = { ref: "dailyCanvas" }
const _hoisted_19 = { class: "chart-card" }
const _hoisted_20 = { class: "chart-title-row" }
const _hoisted_21 = { class: "chart-shell" }
const _hoisted_22 = { ref: "monthlyCanvas" }
const _hoisted_23 = { class: "chart-card" }
const _hoisted_24 = { class: "chart-title-row" }
const _hoisted_25 = { class: "chart-shell" }
const _hoisted_26 = { ref: "quarterlyCanvas" }
const _hoisted_27 = { class: "chart-card chart-wide" }
const _hoisted_28 = { class: "chart-title-row" }
const _hoisted_29 = { class: "chart-shell" }
const _hoisted_30 = { ref: "yearlyCanvas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "hero-kicker" }, "Thống kê góp ý"),
        _createElementVNode("h1", null, "Dashboard góp ý người dân"),
        _createElementVNode("p", null, "Theo dõi số lượng góp ý theo ngày, tháng, quý và năm.")
      ], -1)),
      _createVNode(_component_Button, {
        label: "Làm mới",
        icon: "pi pi-refresh",
        loading: $setup.isLoading,
        onClick: $setup.loadDashboard
      }, null, 8, ["loading", "onClick"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Từ thời gian", -1)),
          _createVNode(_component_Calendar, {
            modelValue: $setup.timeFrom,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.timeFrom) = $event)),
            showTime: "",
            placeholder: "Chọn thời gian bắt đầu"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Đến thời gian", -1)),
          _createVNode(_component_Calendar, {
            modelValue: $setup.timeTo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.timeTo) = $event)),
            showTime: "",
            placeholder: "Chọn thời gian kết thúc"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Phân loại", -1)),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.selectedFeedbackKindId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedFeedbackKindId) = $event)),
            options: $setup.feedbackKindOptions,
            optionLabel: "content",
            optionValue: "id",
            placeholder: "Tất cả",
            filter: true,
            onChange: $setup.loadDashboard
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "Hôm nay",
            outlined: "",
            onClick: $setup.selectToday
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "7 ngày",
            outlined: "",
            onClick: $setup.selectLast7Days
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "Tháng này",
            outlined: "",
            onClick: $setup.selectThisMonth
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "Năm này",
            outlined: "",
            onClick: $setup.selectThisYear
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Tổng góp ý", -1)),
        _createElementVNode("strong", null, _toDisplayString($setup.totalFeedback), 1),
        _cache[8] || (_cache[8] = _createElementVNode("small", null, "Trong khoảng đang chọn", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("span", null, "Ngày nhiều nhất", -1)),
        _createElementVNode("strong", null, _toDisplayString($setup.peakDay.value), 1),
        _createElementVNode("small", null, _toDisplayString($setup.peakDay.label), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Tháng nhiều nhất", -1)),
        _createElementVNode("strong", null, _toDisplayString($setup.peakMonth.value), 1),
        _createElementVNode("small", null, _toDisplayString($setup.peakMonth.label), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Phân loại", -1)),
        _createElementVNode("strong", null, _toDisplayString($setup.kindCount), 1),
        _cache[12] || (_cache[12] = _createElementVNode("small", null, "Nhóm góp ý phát sinh", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("article", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[13] || (_cache[13] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Góp ý theo ngày"),
            _createElementVNode("p", null, "Diễn biến chi tiết trong khoảng thời gian lọc.")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString($setup.dailyLabels.length) + " ngày", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("canvas", _hoisted_18, null, 512)
        ])
      ]),
      _createElementVNode("article", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[14] || (_cache[14] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Góp ý theo tháng"),
            _createElementVNode("p", null, "Tổng hợp theo từng tháng.")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString($setup.monthlyLabels.length) + " tháng", 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("canvas", _hoisted_22, null, 512)
        ])
      ]),
      _createElementVNode("article", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[15] || (_cache[15] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Góp ý theo quý"),
            _createElementVNode("p", null, "So sánh khối lượng góp ý theo quý.")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString($setup.quarterlyLabels.length) + " quý", 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("canvas", _hoisted_26, null, 512)
        ])
      ]),
      _createElementVNode("article", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[16] || (_cache[16] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Góp ý theo năm"),
            _createElementVNode("p", null, "Xu hướng dài hạn qua các năm.")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString($setup.yearlyLabels.length) + " năm", 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("canvas", _hoisted_30, null, 512)
        ])
      ])
    ])
  ]))
}